import { isGlobalFeatureEnabled } from "owa-feature-flags/lib/utils/isFeatureEnabled";

/**
 * Checks once per entry-point call whether to use the native HTML Sanitizer API.
 * The result should be captured and passed down — inner functions must not re-check the flight.
 *
 * The `allowElement` method check guards against browsers that shipped an older experimental
 * Sanitizer API: `Sanitizer` and `setHTML` exist, but the sanitizer is configured via a
 * constructor config object and lacks the builder-style methods
 * (allowElement/allowAttribute/removeElement/removeAttribute/setComments/setDataAttributes)
 * that SanitizerConfigAdapter.toNativeSanitizerConfig relies on. All of those methods ship
 * together in the same spec revision, so probing `allowElement` alone is sufficient. Without
 * this guard the native path runs on those browsers and throws "allowElement is not a function".
 */
export function shouldUseNativeSanitizer(): boolean {
    return (isGlobalFeatureEnabled("fwk-use-native-html-sanitizer", true) &&
        typeof globalThis.Sanitizer !== "undefined" &&
        typeof globalThis.Sanitizer.prototype?.allowElement === "function" &&
        typeof HTMLElement.prototype.setHTML === "function");
}
